import type { ManualCreateUserDto, UserWithSecrets } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";

export const registerByAdmin = async (data: ManualCreateUserDto) => {
  const response = await axios.post<
    UserWithSecrets,
    AxiosResponse<UserWithSecrets>,
    ManualCreateUserDto
  >("user/", data);
  console.log("response", response);
  return response.data;
};

export const useRegisterByAdmin = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: registerByAdminFn,
  } = useMutation({
    mutationFn: registerByAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["filter-user"] });
      queryClient.invalidateQueries({ queryKey: ["filter-ambassador"] });
      queryClient.invalidateQueries({ queryKey: ["filter-admin"] });
    },
  });

  return { registerByAdmin: registerByAdminFn, loading, error };
};
